import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../system/system.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptorService implements HttpInterceptor {
    constructor(
        private systemService: SystemService
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes('localhost') || request.url.includes('gateway.genos')) {
            request = request.clone({
                setHeaders: {
                    'x-device-info': this.systemService.getDeviceId()!
                }
            })
        }
        if (request.url.includes('localhost')) {
            request = request.clone({
                setHeaders: {
                    'x-user-context': JSON.stringify({ _id: this.systemService.getLocalStorage('userId') }),
                }
            });
        }
        if (!request.headers.has('Authorization')) {
            const token = this.systemService.getLocalStorage('token');
            if (token && !request.url.startsWith('/upload')) {
                request = request.clone({
                    setHeaders: {
                        Authorization: token,
                    }
                });
            }
        }
        return next.handle(request);
    }
}
